import { Stack } from "expo-router";
import { PageLayout } from "app/features/navigation/templates/PageLayout";
import { format } from "date-fns";

const getFormattedDate = () => {
  return format(new Date(), "eee. dd MMM yyyy");
};

export default function ShiftHandoverLayout() {
  const screenName = "Shift Handover";
  const subtitle = getFormattedDate();

  return (
    <PageLayout
      screenName={screenName}
      titleClassName="text-primary-800"
      headerClassName="mx-dashboard"
      className="py-dashboard"
      subtitle={subtitle}
    >
      <Stack
        screenOptions={{
          headerShown: false,
          contentStyle: { backgroundColor: "white" },
        }}
      />
    </PageLayout>
  );
}
